import { useNavigate } from "react-router-dom";
import { MdArrowBack } from "react-icons/md";
import { useTheme } from "../../hooks/useTheme";
import styles from "./BackButton.module.scss";

type Props = {
  iconName?: string;
  likeText?: boolean;
};

const BackButton = ({ iconName = "arrow-back", likeText }: Props) => {
  const { theme } = useTheme();
  const navigate = useNavigate();

  return (
    <div className={styles.backButtonContainer}
      onClick={() => navigate(-1)}
      role="button"
      tabIndex={0}
      aria-label="Назад"
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          navigate(-1);
        }
      }}
    >
      <MdArrowBack
        className={styles.backButton}
        size={24}
        color={likeText ? theme.text : ""}
      />
    </div>
  );
};

export default BackButton;
